import React from 'react';
import { Button, Card, Text } from '@fragments';
import {
    IconArrowsTransferUpDown,
    IconBrandMastercard,
    IconChevronLeft,
    IconChevronRight,
    IconSettings,
} from '@tabler/icons-react';
import './styles.scss';

const CONTACTS = [
    { id: 'natalia', name: 'Natalia', tint: 'a' },
    { id: 'james', name: 'James', tint: 'b' },
    { id: 'laura', name: 'Laura', tint: 'c' },
    { id: 'wei', name: 'Wei', tint: 'd' },
    { id: 'arthur', name: 'Arthur', tint: 'e' },
    { id: 'emma', name: 'Emma', tint: 'f' },
    { id: 'lena', name: 'Lena', tint: 'a' },
    { id: 'nuray', name: 'Nuray', tint: 'b' },
];

export default function QuickTransfer() {
    return (
        <Card
            flat
            headerDivider
            title="Quick Transfer"
            icon={<IconArrowsTransferUpDown />}
            action={
                <Button variant="text" color="inverse" size="small" startIcon={<IconSettings />}>
                    Advanced
                </Button>
            }
            footer={
                <Button
                    color="inverse"
                    size="medium"
                    fullWidth
                    disabled
                >
                    Save a New Action
                </Button>
            }
        >
            <div className="quick-transfer__contacts-head">
                <Text.subheading contrast={6}>My Contacts (12)</Text.subheading>
                <span className="quick-transfer__contacts-arrows" aria-hidden="true">
                    <IconChevronLeft />
                    <IconChevronRight />
                </span>
            </div>

            <ul className="quick-transfer__contacts" aria-label="My contacts">
                {CONTACTS.map(({ id, name, tint }) => (
                    <li key={id} className="quick-transfer__contact">
                        <span
                            className={`quick-transfer__avatar quick-transfer__avatar--${tint}`}
                            aria-hidden="true"
                        >
                            <Text.label contrast={9}>{name.charAt(0)}</Text.label>
                        </span>
                        <Text.span contrast={7} maxLines={1}>
                            {name}
                        </Text.span>
                    </li>
                ))}
            </ul>

            <div className="quick-transfer__transfer-box">
                <button type="button" className="quick-transfer__selector">
                    <span className="quick-transfer__selector-chip" aria-hidden="true">
                        <IconBrandMastercard />
                    </span>
                    <Text.label contrast={8} grow maxLines={1}>
                        My Physical Card
                    </Text.label>
                    <IconChevronRight
                        className="quick-transfer__selector-chevron"
                        aria-hidden="true"
                    />
                </button>

                <div className="quick-transfer__amount">
                    <Text.subheading contrast={6}>Enter Amount</Text.subheading>
                    <Text.h1 weight={500} contrast={5}>
                        US$ 0
                    </Text.h1>
                    <div className="quick-transfer__available">
                        <Text.caption contrast={6}>Available:</Text.caption>
                        <Text.label contrast={9}>$16,058.94</Text.label>
                    </div>
                </div>
            </div>
        </Card>
    );
}
